/* ═══════════════════════════════════════════════════════════════════
   NOVA SOLUTION - MAIN JAVASCRIPT (FIXED & UNIFIED)
   All bugs fixed, duplicates removed, null checks added
   ═══════════════════════════════════════════════════════════════════ */

// ═══ PARTICLES.JS INITIALIZATION ═══
if (typeof particlesJS !== 'undefined' && document.getElementById('particles-js')) {
  particlesJS('particles-js', {
    particles: {
      number: { value: 80, density: { enable: true, value_area: 800 } },
      color: { value: '#FFFFFF' },
      shape: { type: 'circle' },
      opacity: { value: 0.6 },
      size: { value: 2, random: true },
      line_linked: { enable: true, distance: 150, color: '#FFFFFF', opacity: 0.3, width: 1 },
      move: { enable: true, speed: 2, direction: 'none', random: false, straight: false, out_mode: 'out', bounce: false }
    },
    interactivity: {
      detect_on: 'canvas',
      events: {
        onhover: { enable: true, mode: 'repulse' },
        onclick: { enable: false },
        resize: true
      },
      modes: {
        repulse: { distance: 200, duration: 0.4 }
      }
    },
    retina_detect: true
  });
}

// ═══ TYPEWRITER EFFECT (Homepage only) ═══
const typewriterEl = document.getElementById('typewriterTarget');
if (typewriterEl) {
  const phrases = ['Convert', 'Scale', 'Dominate', 'Sell More', 'Grow Revenue', 'Outperform'];
  let phraseIdx = 0, charIdx = 0, isDeleting = false;

  function typewrite() {
    const current = phrases[phraseIdx];
    if (!isDeleting) {
      typewriterEl.textContent = current.substring(0, charIdx + 1);
      charIdx++;
      if (charIdx === current.length) {
        setTimeout(() => { isDeleting = true; typewrite(); }, 2200);
        return;
      }
      setTimeout(typewrite, 90 + Math.random() * 40);
    } else {
      typewriterEl.textContent = current.substring(0, charIdx - 1);
      charIdx--;
      if (charIdx === 0) {
        isDeleting = false;
        phraseIdx = (phraseIdx + 1) % phrases.length;
        setTimeout(typewrite, 400);
        return;
      }
      setTimeout(typewrite, 45);
    }
  }
  setTimeout(typewrite, 800);
}

// ═══ TESTIMONIAL SLIDER ═══
const slides = document.getElementById('sliderSlides');
if (slides) {
  const dotsContainer = document.getElementById('sliderDots');
  const totalSlides = slides.children.length;
  let currentSlide = 0;
  let autoplayTimer;

  function getSlidesPerView() {
    return window.innerWidth < 768 ? 1 : 3;
  }

  let slidesPerView = getSlidesPerView();
  let totalPositions = Math.max(1, totalSlides - slidesPerView + 1);

  function createDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = '';
    for (let i = 0; i < totalPositions; i++) {
      const dot = document.createElement('div');
      dot.className = 'slider-dot' + (i === currentSlide ? ' active' : '');
      dot.addEventListener('click', () => goToSlide(i));
      dotsContainer.appendChild(dot);
    }
  }

  createDots();

  function goToSlide(n) {
    slidesPerView = getSlidesPerView();
    totalPositions = Math.max(1, totalSlides - slidesPerView + 1);
    if (n < 0) n = totalPositions - 1;
    if (n >= totalPositions) n = 0;
    currentSlide = n;
    const percentage = (100 / slidesPerView) * n;
    slides.style.transform = `translateX(-${percentage}%)`;
    document.querySelectorAll('.slider-dot').forEach((d, i) => d.classList.toggle('active', i === n));
    resetAutoplay();
  }

  function nextSlide() { goToSlide(currentSlide + 1); }
  function prevSlide() { goToSlide(currentSlide - 1); }

  const nextBtn = document.getElementById('sliderNext');
  const prevBtn = document.getElementById('sliderPrev');
  if (nextBtn) nextBtn.addEventListener('click', nextSlide);
  if (prevBtn) prevBtn.addEventListener('click', prevSlide);

  function resetAutoplay() {
    clearInterval(autoplayTimer);
    autoplayTimer = setInterval(nextSlide, 5000);
  }
  resetAutoplay();

  // Touch support
  let touchStartX = 0;
  slides.addEventListener('touchstart', e => {
    touchStartX = e.touches[0].clientX;
    clearInterval(autoplayTimer);
  }, { passive: true });

  slides.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) diff > 0 ? nextSlide() : prevSlide();
    resetAutoplay();
  }, { passive: true });

  window.addEventListener('resize', () => {
    slidesPerView = getSlidesPerView();
    totalPositions = Math.max(1, totalSlides - slidesPerView + 1);
    if (currentSlide >= totalPositions) currentSlide = totalPositions - 1;
    createDots();
    goToSlide(currentSlide);
  });
}

// ═══ REVEAL ON SCROLL ═══
// FIX: Single declaration only — removed duplicate
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((e, i) => {
    if (e.isIntersecting) {
      setTimeout(() => e.target.classList.add('visible'), i * 60);
      revealObserver.unobserve(e.target);
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

document.querySelectorAll('.reveal, .reveal-left, .stagger-children').forEach(el => revealObserver.observe(el));

// ═══ NAV SCROLL & PROGRESS ═══
// FIX: Null checks added, single scroll listener
const mainNav = document.getElementById('mainNav');
const scrollProgress = document.getElementById('scrollProgress');

window.addEventListener('scroll', () => {
  if (mainNav) mainNav.classList.toggle('scrolled', scrollY > 60);
  if (scrollProgress) {
    const p = (scrollY / (document.documentElement.scrollHeight - innerHeight)) * 100;
    scrollProgress.style.width = p + '%';
  }

  // Parallax on hero shapes
  const s = scrollY * 0.3;
  document.querySelectorAll('.geo').forEach((g, i) => {
    g.style.transform = `translateY(${s * (0.1 + i * 0.05)}px)`;
  });
});

// ═══ MOBILE TOGGLE ═══
// FIX: Null check added
const mobileToggle = document.getElementById('mobileToggle');
const navLinks = document.getElementById('navLinks');
if (mobileToggle && navLinks) {
  mobileToggle.addEventListener('click', () => navLinks.classList.toggle('open'));
}

// ═══ MOBILE MEGA MENU TOGGLE ═══
const megaParent = document.getElementById('megaParent');
if (megaParent) {
  megaParent.addEventListener('click', function(e) {
    if (window.innerWidth <= 960) {
      e.preventDefault();
      this.classList.toggle('mob-open');
    }
  });
}

// ═══ SMOOTH SCROLL ═══
document.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
  const target = document.querySelector(a.getAttribute('href'));
  if (target) {
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
    if (navLinks) navLinks.classList.remove('open');
  }
}));

// ═══ CURSOR GLOW ═══
// FIX: Single listener, null check added
const cursorGlow = document.getElementById('cursorGlow');
if (cursorGlow) {
  document.addEventListener('mousemove', e => {
    cursorGlow.style.left = e.clientX + 'px';
    cursorGlow.style.top = e.clientY + 'px';
  });
}

// ═══ COUNTER ANIMATION ═══
// FIX: Single declaration only — removed duplicate
const counterObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    const el = entry.target;
    const target = parseInt(el.dataset.target || el.dataset.count || el.textContent.match(/\d+/)?.[0] || 0);
    const suffix = el.dataset.suffix || el.textContent.replace(/[\d,]+/, '');
    let current = 0;
    const step = Math.max(1, Math.ceil(target / 50));
    const timer = setInterval(() => {
      current = Math.min(current + step, target);
      el.textContent = current + suffix;
      if (current >= target) clearInterval(timer);
    }, 25);
    counterObserver.unobserve(el);
  });
}, { threshold: 0.5 });

document.querySelectorAll('.number[data-target], .mv[data-count]').forEach(el => counterObserver.observe(el));

// ═══ BAR CHART ANIMATION ═══
const barObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    entry.target.querySelectorAll('.bar').forEach(bar => {
      setTimeout(() => bar.classList.add('anim'), parseInt(bar.dataset.delay || 0));
    });
    barObserver.unobserve(entry.target);
  });
}, { threshold: 0.3 });
document.querySelectorAll('.bar-chart').forEach(el => barObserver.observe(el));

// ═══ LINE CHART ANIMATION ═══
const lineObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    entry.target.querySelectorAll('.lp').forEach(p => p.classList.add('anim'));
    entry.target.querySelectorAll('.af').forEach(a => setTimeout(() => a.classList.add('anim'), 500));
    entry.target.querySelectorAll('.dd').forEach(d => setTimeout(() => d.classList.add('anim'), parseInt(d.dataset.delay || 0)));
    lineObserver.unobserve(entry.target);
  });
}, { threshold: 0.3 });
document.querySelectorAll('.lcw').forEach(el => lineObserver.observe(el));

// ═══ DONUT CHART ANIMATION ═══
const donutChart = document.getElementById('donutChart');
if (donutChart) {
  const donutObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const circ = 2 * Math.PI * 70;
      const vals = [35, 28, 22, 15];
      let offset = 0;
      ['d1', 'd2', 'd3', 'd4'].forEach((id, i) => {
        const el = document.getElementById(id);
        if (!el) return;
        const seg = (vals[i] / 100) * circ;
        setTimeout(() => {
          el.style.strokeDasharray = seg + ' ' + (circ - seg);
          el.style.strokeDashoffset = -offset;
        }, i * 200);
        offset += seg;
      });
      donutObserver.unobserve(entry.target);
    });
  }, { threshold: 0.3 });
  donutObserver.observe(donutChart);
}

// ═══ PORTFOLIO FILTER ═══


const pgrid = document.querySelector('.pgrid');
const allCards = Array.from(document.querySelectorAll('.pcard'));

document.querySelectorAll('.pfb').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.pfb').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const filter = btn.dataset.filter;
    pgrid.innerHTML = '';

    const filteredCards = filter === 'all'
      ? allCards
      : allCards.filter(card => card.dataset.category.split(',').includes(filter));

    filteredCards.forEach(card => pgrid.appendChild(card));
  });
});

// ═══ FAQ ACCORDION ═══
// FIX: Toggle support added — clicking active item will close it
document.querySelectorAll('.faq-item').forEach(item => {
  const question = item.querySelector('.faq-question');
  if (question) {
    question.addEventListener('click', () => {
      const isActive = item.classList.contains('active');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('active'));
      if (!isActive) item.classList.add('active');
    });
  }
});

// Activate first FAQ on load
const firstFaq = document.querySelector('.faq-item');
if (firstFaq) firstFaq.classList.add('active');